/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand
 */
export interface FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand
     */
    GameSystemName: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand
     */
    YandexSecret: string;
}

/**
 * Check if a given object implements the FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand interface.
 */
export function instanceOfFxIdApplicationStoreYandexGamesRedeemYandexBonusCommand(value: object): value is FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('YandexSecret' in value) || value['YandexSecret'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandFromJSON(json: any): FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand {
    return FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandFromJSONTyped(json, false);
}

export function FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'GameSystemName': json['GameSystemName'],
        'YandexSecret': json['YandexSecret'],
    };
}

export function FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandToJSON(json: any): FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand {
    return FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandToJSONTyped(json, false);
}

export function FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandToJSONTyped(value?: FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'GameSystemName': value['GameSystemName'],
        'YandexSecret': value['YandexSecret'],
    };
}

